import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "./components/Layout";
import LayoutLogin from "./components/LayoutLogin";
import { useUserContext } from "./context/User";
import AboutPage from "./pages/About";
import Adopt from "./pages/Adopt";
import IndexPage from "./pages/Index";
import LoginPage from "./pages/Login";
import PetPage from "./pages/Pet";
import ProductsPage from "./pages/Products";
import ShelterPage from "./pages/Shelter";
import SheltersPage from "./pages/Shelters";

export default function App() {
  const { user, populateFromStorage, saveToStorage } = useUserContext();

  useEffect(() => {
    populateFromStorage();
  }, []);

  useEffect(() => {
    saveToStorage();
  }, [user]);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<IndexPage />} />
      </Route>
      <Route element={<Layout />}>
        <Route path="/pet/:id" element={<PetPage />} />
        <Route path="/pet/:id/shelter" element={<ShelterPage />} />
        <Route path="/adopt/:id" element={<Adopt />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/shelters" element={<SheltersPage />} />
      </Route>
      <Route element={<LayoutLogin />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
    </Routes>
  );
}
